(function(){
	'use strict';
	angular
	.module('app')
	.controller('SolucoesController', SolucoesController)
	.filter('trustAs', function ($sce) {
		return function (input, type) {
			if (typeof input === "string") {
				return $sce.trustAs(type || 'html', input);
			}
			return "";
		};
	});
	function SolucoesController(API,$sce, $timeout, $state, $scope, $location, $rootScope){
		let vm = this;
		vm.textButton = "Enviar";
		vm.callToMe = callToMe;
		vm.call = {
			name: '',
			phone: '',
			email: ''
		};

		vm.$onInit = () => {
			getFromAPI();
		}

		function getFromAPI() {
			API.get('projeto').then(result => {
				vm.solucoes = result.data.sort(function(a, b) {
					return a.ordem_projeto - b.ordem_projeto;
				});
			});
		}

		function callToMe(data) {
			vm.textButton = "Enviando";
			vm.disabled = true;
			API.post('callToMe', data).then(result => {
				console.log(result);
				vm.textButton = "Enviado :)";
				vm.call = {};
				$timeout(() => {
					vm.textButton = "Enviar";
					vm.disabled = false;
				}, 7000)
			});
		}
	}//fim controller
})();